import { OneCRepository } from '../repositories/onec.repository'
import { OneCPayloadT } from '../types/onec.types'
import {
    OneCResponseT,
    OneCGetParamsT,
    ResendDispatcher,
    OneCDeliveryResponse,
    OneCDeliveryGetParams,
    ResendDelivery,
    SdtOrdersParams,
    SdtOrdersResponse,
    SdtOrdersResendParams,
    OneCGetTripsParams,
    OneCTripsResponse,
} from '@/core/types/one_c.types'

const oneCRepository = new OneCRepository()

export class OneCService {
    async restoreOrders(onec_payload: OneCPayloadT): Promise<void> {
        await oneCRepository.restoreOrders(onec_payload)
        return
    }

    async resendTrips(onec_payload: OneCPayloadT): Promise<void> {
        await oneCRepository.resendTrips(onec_payload)
        return
    }

    async getList(params: OneCGetParamsT): Promise<OneCResponseT> {
        const response = await oneCRepository.getList(params)
        return response.data
    }

    async getTrips(params: OneCGetTripsParams): Promise<OneCTripsResponse> {
        const response = await oneCRepository.getTrips(params)
        return response.data
    }

    async getDeliveryList(params: OneCDeliveryGetParams): Promise<OneCDeliveryResponse> {
        const response = await oneCRepository.getDeliveryList(params)
        return response.data
    }

    async getSdtOrders(params: SdtOrdersParams): Promise<SdtOrdersResponse> {
        const response = await oneCRepository.getSdtOrders(params)
        return response.data
    }

    async resend(orderId: number): Promise<void> {
        const response = await oneCRepository.resend(orderId)
        return response.data
    }

    async resendDeliveryById(id: number): Promise<void> {
        const response = await oneCRepository.resendDeliveryById(id)
        return response.data
    }

    async resendDispatcher(payload: ResendDispatcher): Promise<void> {
        const response = await oneCRepository.resendDispatcher(payload)
        return response.data
    }

    async resendDelivery(payload: ResendDelivery): Promise<void> {
        const response = await oneCRepository.resendDelivery(payload)
        return response.data
    }

    async resendSdt(payload: SdtOrdersResendParams): Promise<void> {
        const response = await oneCRepository.resendSdt(payload)
        return response.data
    }

    async resendSdtOrder(id: number): Promise<void> {
        const response = await oneCRepository.resendSdtOrder(id)
        return response.data
    }

    async syncOnec(form_data: FormData): Promise<void> {
        const response = await oneCRepository.syncOnec(form_data)
        return response.data
    }
}
